import { useState, useRef, useEffect } from "react";
import { Input, Button } from "antd";
import "./style.scss";
import { useTranslation } from "react-i18next";

const SearchDropdown = ({ search }) => {
  const { t } = useTranslation();

  const [searchedValue, setSearchedValue] = useState<any>({
    medHubId: { key: "customerId", value: "" },
    phone: { key: "CUSTOMER_PHONE", value: "" },
    reqId: { key: "ids", value: "" },
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const menuRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !inputRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="search-dropdown-container">
      <div
        className="search-box-div"
        ref={inputRef}
        onClick={() => setIsMenuOpen(true)}
      >
        {!!!searchedValue?.phone?.value &&
        !!!searchedValue?.medHubId?.value &&
        !!!searchedValue?.reqId?.value ? (
          <p>{t("search.searchRequests")}</p>
        ) : (
          <>
            {!!searchedValue?.phone?.value && (
              <span>
                {t("search.customerPhone")}: {searchedValue?.phone?.value}{" "}
              </span>
            )}
            {!!searchedValue?.medHubId?.value && (
              <span>
                {" "}
                {t("search.medhubId")}: {searchedValue?.medHubId?.value}
              </span>
            )}
            {!!searchedValue?.reqId?.value && (
              <span>
                {" "}
                {t("search.requestId")}: {searchedValue?.reqId?.value}
              </span>
            )}
          </>
        )}
      </div>

      {isMenuOpen && (
        <div className="search-dropdown-menu" ref={menuRef}>
          <h3 className="search-title">{t("search.searchRequests")}</h3>
          <div className="search-fields">
            <div className="search-fields-item">
              <p>{t("search.clientMobile")}</p>
              <Input
                onChange={(e) =>
                  setSearchedValue({
                    ...searchedValue,
                    phone: { key: "CUSTOMER_PHONE", value: e.target.value },
                  })
                }
                value={searchedValue?.phone?.value}
                placeholder={t("search.clientMobile")}
              />
            </div>

            <div className="search-fields-item">
              <p>{t("search.clientMedhubId")}</p>
              <Input
                onChange={(e) =>
                  setSearchedValue({
                    ...searchedValue,
                    medHubId: { key: "customerId", value: e.target.value },
                  })
                }
                value={searchedValue?.medHubId?.value}
                placeholder={t("search.clientMedhubId")}
              />
            </div>

            <div className="search-fields-item">
              <p>{t("search.requestId")}</p>
              <Input
                onChange={(e) =>
                  setSearchedValue({
                    ...searchedValue,
                    reqId: { key: "ids", value: e.target.value },
                  })
                }
                value={searchedValue?.reqId?.value}
                placeholder={t("search.requestId")}
              />
            </div>
          </div>
          <div className="search-buttons">
            <Button
              type="primary"
              onClick={() => {
                search?.searchAction?.(searchedValue);
                setIsMenuOpen(false);
                setIsSearched(false);
              }}
              disabled={
                !!!searchedValue?.phone?.value &&
                !!!searchedValue?.medHubId?.value &&
                !!!searchedValue?.reqId?.value
              }
              loading={search?.btnLoading}
            >
              {t("search.find")}
            </Button>
            <Button
              onClick={() => {
                setIsMenuOpen(false);
                setSearchedValue(undefined);
                search?.searchAction?.(undefined);
              }}
            >
              {t("search.cancel")}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;
